import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/celulares/schemes/list', data, {params})
  }
}